import AjaxForm from "../classes/AjaxForm";

export default () => {
	$('.js-ajax-form').each((index, form) => {
		const instance = new AjaxForm();

		instance.beforeAjax = () => {
			instance.$form.find('.js-error-message').hide();
			instance.$form.find('.js-success-message').hide();
			instance.$form.find('.js-form-content').hide();
			instance.$form.find('.js-loader').show();

			window.scrollTo(0, instance.$form.offset().top - 100);
		};
		instance.afterAjax = () => {
			instance.$form.find('.js-loader').hide();
		};
		instance.onError = () => {
			instance.$form.find('.js-error-message').show();
		};
		instance.onSuccess = (data) => {
			instance.$form.find('.js-success-message').show();

			if (data.download_url) {
				window.location.href = data.download_url;
			}
		};
		
		instance.init(form);
	});
}